import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SOILSPECIE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SoilSpecie.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SoilSpecie.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const SOILSPECIE_CONFIG = {
  entityName: 'SoilSpecie',
  localizationKey: 'Planning::Entity.SoilSpecie',
  fields: SOILSPECIE_FIELDS,
  permission: 'PlanningEnvironment.SoilSpecies',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
